import { Component } from "react";
import styled from "styled-components";
import { device } from "../../../../shared/styles/device";
import Layout from "../../components/global/Layout";
import Seo from "../../components/global/Seo";
import { MediaSection } from "../../components/speed-recruiting/Media";
import { ActiveCampaignForm } from "../../components/talentpool/agentur/activecampaignForm";
import { HeroIntroAgenturen } from "../../components/talentpool/agentur/agenturHeroIntro";
import { TagCloud } from "../../components/talentpool/agentur/tagCloud";
import { TestimonialsSectionTP } from "../../components/talentpool/talente/testimonials";

const IndexContainer = styled.div`
    &>section {
      margin-bottom: 64px;
    }

    @media ${device.tablet} {
      &>section {
        margin-bottom: 128px;
      }
    }
`;

interface TPArbeitgeberProps {
  data: {
    heroImage: any;
  };
}
export default class TPArbeitgeberPage extends Component<TPArbeitgeberProps> {

  constructor(props: TPArbeitgeberProps) {
    super(props);
  }

  render() {
    const title = "Deine neuen Mitarbeitenden im Talentpool"
    const description = "Finde junge Talente via Active Sourcing im STELL-MICH-EIN Talentpool für deine Agentur. Jetzt registrieren und in den Disziplinen Design, Beratung, Online Marketing und Text Talente entdecken."

    return (
      <>
        <Seo title={title} description={description} />
        <Layout preview={false} headerAbsolute={false}>
          <IndexContainer>
            <HeroIntroAgenturen />
            <TagCloud />
            <TestimonialsSectionTP />
            <ActiveCampaignForm />
            <MediaSection />
          </IndexContainer>
        </Layout>
      </>
    )
  }

}

